import {
    FETCH_DIRECT_CONSULTATIONS,
    FETCH_DIRECT_CONSULTATION,
    UPDATE_DIRECT_CONSULTATION,
    REMOVE_DIRECT_CONSULTATIONS
} from '@/redux/actions/types';

const INIT_STATE = {
    items: [],
    detail: null,
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_DIRECT_CONSULTATIONS:
            return {
                ...state,
                items: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1, 10),
                    total: parseInt(action.payload?.total || 0, 10),
                    perPage: parseInt(action.payload?.per_page || 30, 10)
                }
            };
        case FETCH_DIRECT_CONSULTATION:
            return { ...state, detail: action.payload || null };
        case UPDATE_DIRECT_CONSULTATION:
            return { ...state, detail: action.payload || state.detail };
        case REMOVE_DIRECT_CONSULTATIONS:
            return {
                ...state,
                items: state.items.filter(item => !action.payload.includes(item.id))
            };
        default:
            return state;
    }
};
